import React from "react";
import { Modal } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import MyIcon from "../Common/MyIcon";
import InfoIcon from "../../assets/icons/Icon_Library/application icons/general/movable.svg2";
import DetailsForSolutionModals from "../Solutions/DetailsForSolutionModals";
import {
  SolutionType,
  useGetSolutionByUuidQuery,
} from "../store/slices/settingsSlice";

export default function AvailableSolutionInfoRouteModal() {
  const { solutionUuid } = useParams<{ solutionUuid: string }>();
  const navigate = useNavigate();
  const response = useGetSolutionByUuidQuery(
    { uuid: solutionUuid || "" },
    { skip: !solutionUuid }
  );
  const solution = response.data as SolutionType | undefined;
  const closeModal = () => navigate("/library/solutions/available");

  return (
    <Modal show onHide={closeModal} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>
          <div className="d-flex align-items-center svg-white">
            <MyIcon Icon={InfoIcon} width={30} />
            <span className="ms-3 fs-3 fw-bold">Solution Information</span>
          </div>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {response.isLoading ? (
          <div className="d-flex justify-content-center p-5">
            <div className="spinner-border" role="status" />
          </div>
        ) : solution ? (
          <DetailsForSolutionModals solution={solution} useRouteModal />
        ) : (
          <div className="alert alert-danger m-0">Unable to load this solution.</div>
        )}
      </Modal.Body>
    </Modal>
  );
}
